import React from "react";
import { Link } from "react-router-dom";
import { FaBars, FaArrowLeft } from "react-icons/fa";
import "./MobileHeader.module.css";

export interface MobileHeaderProps {
  title?: string;
  onMenuClick?: () => void;
  showBack?: boolean;
  onBackClick?: () => void;
  actions?: React.ReactNode;
  showLogo?: boolean;
  className?: string;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  title,
  onMenuClick,
  showBack = false,
  onBackClick,
  actions,
  showLogo = true,
  className = ''
}) => {
  const logoUrl = new URL(
    '../../../static/Vojomo_Horiz_fullcolor_rgb.png',
    import.meta.url
  ).href;

  return (
    <header
      className={`fixed top-0 left-0 right-0 w-full z-[998] bg-white shadow-md ${className}`}
      style={{
        backgroundColor: '#ffffff',
        borderBottom: '1px solid rgba(44, 21, 97, 0.1)'
      }}
    >
      <div className="flex items-center justify-between px-4 py-3 w-full">
        {/* Left side - Menu or Back button */}
        <div className="flex items-center gap-3 flex-1 basis-0">
          {showBack ? (
            <button
              onClick={onBackClick}
              className="p-2 hover:bg-[#eeddf7] rounded-lg transition-all duration-200 min-w-touch min-h-touch flex items-center justify-center"
              aria-label="Go back"
            >
              <FaArrowLeft className="text-[#2c1561]" size={20} />
            </button>
          ) : onMenuClick ? (
            <button
              onClick={onMenuClick}
              className="p-2 hover:bg-[#eeddf7] rounded-lg transition-all duration-200 min-w-touch min-h-touch flex items-center justify-center"
              aria-label="Open menu"
            >
              <FaBars className="text-[#2c1561]" size={22} />
            </button>
          ) : null}
        </div>

        {/* Center - Logo or Title */}
        <div className="flex items-center justify-center shrink-0">
          {showLogo ? (
            <Link to="/" className="transition-transform hover:scale-105">
              <img
                src={logoUrl}
                alt="Vojomo"
                className="h-7"
              />
            </Link>
          ) : title ? (
            <h1 className="text-lg font-bold text-[#2c1561] truncate px-2">
              {title}
            </h1>
          ) : null}
        </div>

        {/* Right side - Actions */}
        <div className="flex items-center gap-2 flex-1 basis-0 justify-end">
          {actions}
        </div>
      </div>
    </header>
  );
};
